require('./pivot');



//////////////////
// WEBPACK FOOTER
// ./node_modules/aframe/src/extras/components/index.js
// module id = 2059
// module chunks = 0